import { useContext, useEffect, useState, useRef } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';

import List from '../../components/list/List';
import { get_testing_hq_doc_list, get_testing_type, get_testing_list, get_testing_schedule_list, download_testing_hq_doc } from '../../utils/restapi';
import './list.css';

const TestingHqDocList = () => {
  const { testingHqs } = useContext(TestingHqContext);

  const listRef = useRef(null);

  // 시험유형 관련 상태만 유지
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);
  const [testingSchedules, setTestingSchedules] = useState([]);

  const [testingObj, setTestingObj] = useState(null);
  const [testingScheduleObj, setTestingScheduleObj] = useState(null);

  // List에서 사용할 데이터 가져오기 함수
  const handleGetData = async (params) => {
    console.log("[handleGetData] params:", params);
    const requestParams = {
      hcodes: testingHqs.map(hq => hq.code).join(','),
      ...params
    };

    if (testingObj && testingObj.testing_id) {
      requestParams.testing_id = testingObj.testing_id;
    }

    if (testingScheduleObj && testingScheduleObj.testing_schedule_id) {
      requestParams.testing_schedule_id = testingScheduleObj.testing_schedule_id;
    }

    console.log("[handleGetData] requestParams:", requestParams);
    const response = await get_testing_hq_doc_list(requestParams);
    console.log("[handleGetData] response:", response);
    return response;
  };

  // 시험유형 데이터 가져오기
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const response = await get_testing_type();
      console.log("getTestingTypes:", response);
      setTestingTypes(response); // API 응답 구조에 따라 조정
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTestings = async (type) => {
    console.log(`getTestings called : ${type}`);
    if (!type) {
      setTestings([]);
      return;
    }

    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      // 실제 응답 구조 확인
      console.log("getTestings response:", response);
      setTestings(response.lists); // 응답 구조에 따라 조정
    } catch (error) {
      setTestings([]);
    }
  };

  // 일정에 대한 데이터 가져오기
  const getTestingSchedules = async (testing_id) => {
    console.log(`getTestingSchedules called : ${testing_id}`);
    if (!testing_id) {
      setTestingSchedules([]);
      return;
    }

    try {
      const response = await get_testing_schedule_list({ testing_id, page:1, rowsPerPage:1000, sort:'a_testing_schedule_id', desc:'desc' });
      console.log("getTestingSchedules response:", response);
      setTestingSchedules(response.lists || []); // 응답 구조에 따라 조정
      if (response.lists && response.lists.length === 1) setTestingScheduleObj(response.lists[0]);
    } catch (error) {
      setTestingSchedules([]);
    }
  };

  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ ...testingObj, type: selectedValue });
    console.log("selectedTestingType:", selectedValue);
  };

  // 시험 선택 핸들러 수정
  const handleTestingIdChange = (e) => {
    console.log('handleTestingIdChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting || null);
  };

  const handleTestingScheduleChange = (e) => {
    console.log('handleTestingScheduleChange called');
    const selectedValue = e.target.value;
    const selectedSchedule = testingSchedules.find(obj => obj.testing_schedule_id === parseInt(selectedValue));
    setTestingScheduleObj(selectedSchedule || null);
  };

  const handleDownload = async (item) => {
    if (item.files && item.files.length > 0 && item.files[0].cloud_file_id) {
      try {
        const response = await download_testing_hq_doc(item.files[0].cloud_file_id);
        if (!response.ok) throw new Error('다운로드 실패');
        const blob = await response.blob();
        // 파일명 추출 (Content-Disposition 또는 name)
        let filename = item.files[0].name || 'downloaded_file';
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
          if (filenameMatch && filenameMatch[1]) filename = filenameMatch[1];
        }
        // 다운로드 링크 생성 및 클릭
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        alert('파일 다운로드에 실패했습니다.');
      }
    } else {
      alert('첨부파일이 없습니다.');
    }
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    { 
      name: 'NO.', 
      value: 'a_testing_hq_doc_id',
      renderCell: (item) => item.testing_hq_doc_id
    },
    { 
      name: '문서제목', 
      value: 'a_name',
      renderCell: (item) => item.name
    },
    { 
      name: '첨부파일',
      value: 'a_maxCount',
      renderCell: (item) =>
        item.files && item.files.length > 0 && item.files[0].path ? (
          <button onClick={() => handleDownload(item)}>다운로드</button>
        ) : null
    },
    { 
      name: '작성자', 
      value: 'd_name',
      renderCell: (item) => item.personObj.name
    }
  ];

  // 컴포넌트가 처음 마운트될 때 시험유형 로드
  useEffect(() => {
    getTestingTypes();
  }, []);

  useEffect(() => {
    console.log("type changed:", testingObj?.type);
    if (testingObj?.type) {
      getTestings(testingObj.type);
      listRef.current?.refresh();
    } else {
      setTestings([]);
      setTestingObj(null);
      setTestingScheduleObj(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.type]);

  // 시험유형 변경 시 listRef 새로고침
  useEffect(() => {
    //console.log("testingObj changed:", testingObj?.testing_id);
    if (testingObj && testingObj.testing_id) {
      getTestingSchedules(testingObj.testing_id);
      listRef.current?.refresh();
    } else {
      setTestingSchedules([]);
      setTestingScheduleObj(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  useEffect(() => {
    //console.log("testingScheduleObj changed:", testingScheduleObj?.testing_schedule_id);
    if (testingScheduleObj && testingScheduleObj.testing_schedule_id) {
      listRef.current?.refresh();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingScheduleObj?.testing_schedule_id]);

  return (
    <div id="testing_place_list">
      <div className="head">
        <h1>자료공유</h1>
      </div>
      <div className="body">
        <div className="top">
          <ul className="form">
            <li>
              <label>구분</label>
              <span>
                <select value={testingObj?.type || ''} onChange={handleTestingTypeChange}>
                  <option value="">▒ 선택 ▒</option>
                  {testingTypes.map((obj, index) => (
                    <option key={index} value={obj.code}>
                      {obj.nickname || obj.name}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>시험</label>
              <span>
                <select value={testingObj?.testing_id || ''} onChange={handleTestingIdChange}>
                  <option value="">▒ 선택 ▒</option>
                  {testings.map((obj, index) => (
                    <option key={index} value={obj.testing_id}>
                      {obj.title}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>일정</label>
              <span>
                <select value={testingScheduleObj?.testing_schedule_id || 0} onChange={handleTestingScheduleChange}>
                  <option value="">▒ 일정 ▒</option>
                  {testingSchedules.map((obj, index) => (
                    <option key={index} value={obj.testing_schedule_id}>
                      {obj.testStartDate} ~ {obj.testStopDate}
                    </option>
                  ))}
                </select>
              </span>
            </li>
          </ul>
        </div>
        <div className="middle">
          <List
            ref={listRef}
            headers={headers}
            onGetData={handleGetData}
            className="testing_hq_doc_table"
            initialSort="a_testing_hq_doc_id"
            initialDesc="desc"
            initialRowsPerPage={20}
          />
        </div>
        <div className="bottom">
        </div>
      </div>
    </div>
  );
};

export default TestingHqDocList;
